<template>
  <div class="commercial-banner-slider">
    <vue-slick-carousel
      ref="slick"
      :arrows="false"
      :autoplay="hasMultipleItems"
      :autoplay-speed="8000"
      :dots="false"
      :infinite="hasMultipleItems"
      :pause-on-focus="true"
      :pause-on-hover="true"
      :slides-to-scroll="1"
      :slides-to-show="1"
      :speed="500"
      class="commercial-banner-slider__carousel"
    >
      <div v-for="(banner, index) in items" :key="banner.id || index" class="commercial-banner-slider__slide">
        <a
          v-if="safeHttpUrl(banner.link)"
          class="commercial-banner-slider__link"
          :href="safeHttpUrl(banner.link)"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            class="commercial-banner-slider__image"
            :src="banner.image"
            :alt="banner.title || 'Banner comercial'"
            :loading="index === 0 ? 'eager' : 'lazy'"
            :fetchpriority="index === 0 ? 'high' : 'auto'"
          />
        </a>

        <div v-else class="commercial-banner-slider__link">
          <img
            class="commercial-banner-slider__image"
            :src="banner.image"
            :alt="banner.title || 'Banner comercial'"
            :loading="index === 0 ? 'eager' : 'lazy'"
            :fetchpriority="index === 0 ? 'high' : 'auto'"
          />
        </div>
      </div>
    </vue-slick-carousel>

    <button
      v-if="hasMultipleItems"
      type="button"
      class="commercial-banner-slider__arrow commercial-banner-slider__arrow--previous"
      aria-label="Banner comercial anterior"
      @click="previous"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="m14.7 6.3-5.7 5.7 5.7 5.7" />
      </svg>
    </button>

    <button
      v-if="hasMultipleItems"
      type="button"
      class="commercial-banner-slider__arrow commercial-banner-slider__arrow--next"
      aria-label="Próximo banner comercial"
      @click="next"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="m9.3 6.3 5.7 5.7-5.7 5.7" />
      </svg>
    </button>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import { sanitizeHttpUrl } from "@/utils/safeNavigation";

export default {
  name: "CommercialBannerSlider",
  components: { VueSlickCarousel },
  props: {
    items: { type: Array, default: () => [] },
  },
  computed: {
    hasMultipleItems() {
      return this.items.length > 1;
    },
  },
  methods: {
    safeHttpUrl: sanitizeHttpUrl,
    previous() {
      this.$refs.slick.prev();
    },
    next() {
      this.$refs.slick.next();
    },
  },
};
</script>

<style scoped>
.commercial-banner-slider {
  aspect-ratio: 1920 / 500;
  position: relative;
  width: 100%;
}

.commercial-banner-slider__carousel,
.commercial-banner-slider ::v-deep .slick-list,
.commercial-banner-slider ::v-deep .slick-track,
.commercial-banner-slider ::v-deep .slick-slide,
.commercial-banner-slider ::v-deep .slick-slide > div,
.commercial-banner-slider__slide,
.commercial-banner-slider__link {
  height: 100%;
}

.commercial-banner-slider__link {
  display: block;
  width: 100%;
}

.commercial-banner-slider__image {
  display: block;
  height: 100%;
  object-fit: cover;
  object-position: center;
  width: 100%;
}

.commercial-banner-slider__arrow {
  align-items: center;
  background: rgba(0, 0, 0, 0.56);
  border: 0;
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  display: flex;
  height: clamp(32px, 3vw, 48px);
  justify-content: center;
  padding: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  transition: background-color 160ms ease, transform 160ms ease;
  width: clamp(32px, 3vw, 48px);
  z-index: 2;
}

.commercial-banner-slider__arrow:hover,
.commercial-banner-slider__arrow:focus-visible {
  background: rgba(0, 0, 0, 0.8);
}

.commercial-banner-slider__arrow:focus-visible {
  outline: 2px solid #fff;
  outline-offset: 3px;
}

.commercial-banner-slider__arrow--previous {
  left: clamp(8px, 1.5vw, 20px);
}

.commercial-banner-slider__arrow--next {
  right: clamp(8px, 1.5vw, 20px);
}

.commercial-banner-slider__arrow svg {
  fill: none;
  height: 58%;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2;
  width: 58%;
}

@media (max-width: 720px) {
  .commercial-banner-slider__arrow {
    display: none;
  }
}
</style>
